import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'iq-central-front-end-setting',
  templateUrl: './setting.component.html',
  styleUrls: ['./setting.component.scss']
})
export class SettingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
